import { useIntl } from "react-intl";
import { useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../redux/SubAgentAction";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import { Modal } from "../../common/Modal";
import { EditSubAgentForm } from "./EditSubAgentForm";

export const EditSubAgentDialog = ({ setSwalProps, agentId, oldNickname }) => {
  const intl = useIntl();
  const formikRef = useRef();
  const dispatch = useDispatch();
  const dismissBtnRef = useRef();
  const subAgentState = useSelector(({ subAgent }) => subAgent, shallowEqual);

  const saveValues = (queryParams) => {
    dispatch(actions.editSubAgentList(queryParams)).then((resp) => {
      resp = resp.data;

      if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
        setSwalProps({
          show: true,
          icon: "success",
          title: intl.formatMessage({ id: "success" }),
          text: intl.formatMessage({ id: "editSubAgentSuccess" }),
          onConfirm: () => {
            formikRef.current.resetForm();
            dismissBtnRef.current.click();
            const queryParams = {
              action: "subagentlist",
            };
            dispatch(actions.callSubAgentList(queryParams));
          },
        });
      } else {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    });
  };

  return (
    <div style={{ width: "100%", margin: "0 auto" }}>
      <Modal
        modalId="editSubAgentModal"
        title={intl.formatMessage({ id: "editSubAgent" })}
        dismissBtnRef={dismissBtnRef}
      >
        <div className="p-3 custom-border-bottom">
          <EditSubAgentForm
            formikRef={formikRef}
            saveValues={saveValues}
            agentId={agentId}
            oldNickname={oldNickname}
          />
        </div>
        <div className="p-3 d-flex justify-content-end align-items-center">
          {subAgentState.actionsLoading && (
            <div
              className="spinner-border me-2"
              role="status"
              style={{ scale: "0.55" }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          )}
          <button
            type="button"
            disabled={subAgentState.actionsLoading}
            className="btn btn-primary px-3"
            onClick={() => formikRef.current.submitForm()}
          >
            {intl.formatMessage({ id: "edit" })}
          </button>
        </div>
      </Modal>
    </div>
  );
};
